/* blanks-collection-tracking.js — GA4 click/filter/sort tracking for the blanks
   collection landing page (collection.blanks-home template).

   All listeners are document-level delegations in the CAPTURE phase: the filter
   sidebar (.bh-sidebar-panel) and grid (#CollectionProductGrid) are innerHTML-
   replaced by component-facets.js on every facet AJAX render, and the sidebar
   panel node is moved into #blanks-filter-drawer on mobile — element-bound
   listeners would not survive either. Listeners only: no DOM mutation. */
(function () {
  'use strict';

  var COLLECTION_HANDLE = (window.location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1] || '';

  function track(name, params) {
    if (typeof gtag === 'undefined') return;
    gtag('event', name, params);
  }

  /* GA4 param values cap at 100 chars */
  function clip(s) {
    return (s || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  /* ---------------- blanks_nav_click ---------------- */

  /* Most specific first; container-scoped fallbacks last. */
  var NAV_RULES = [
    ['a.nbh-cat-card, a.bcg-card, a.bbg-card', 'category_pill'],
    ['.bh-slice__see-all, .bcg-view-all, .bbg-view-all', 'section_shop_all'],
    ['.nb-mob-drawer a, #site-menu-sidebar a', 'mobile_drawer'],
    ['#site-search-sidebar a, .nb-mob-search-overlay a', 'search'],
    ['nav.nb-nav a', 'mega_nav'],
    ['a.product-item-link-wraper, a.product-item__title', 'product_card']
  ];

  function navLabel(link, method) {
    var el;
    if (method === 'category_pill') {
      el = link.querySelector('.nbh-cat-card-label, .bcg-card__name, .bbg-card__name');
      if (el) return clip(el.textContent);
    }
    if (method === 'product_card') {
      var card = link.closest('.product-item');
      el = card && card.querySelector('.product-item__title');
      if (el) return clip(el.textContent);
    }
    return clip(link.textContent);
  }

  /* Derive the filter group for a removal chip: the chip href (url_to_remove) is
     the current URL minus one value — the filter param that shrank names the
     group. Read synchronously at click time, before the AJAX render replaces
     the sidebar. */
  function chipGroup(chip) {
    try {
      var current = new URLSearchParams(window.location.search);
      var removed = new URLSearchParams(chip.getAttribute('href').split('?')[1] || '');
      var param = '';
      current.forEach(function (v, k) {
        if (!param && k.indexOf('filter.') === 0 && current.getAll(k).length > removed.getAll(k).length) {
          param = k;
        }
      });
      if (!param) return '';
      var input = document.querySelector('.bh-sb-form input[name="' + param + '"]');
      var details = input && input.closest('details.bh-sb-group');
      var label = details && details.querySelector('.bh-sb-group__label');
      return label ? clip(label.textContent) : param;
    } catch (err) {
      return '';
    }
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!(target instanceof Element)) return;

    /* Product-card color swatches navigate via JS (data-url), no <a> */
    var sw = target.closest('.bh-sw[data-url]');
    if (sw) {
      track('blanks_nav_click', {
        nav_method: 'product_card',
        nav_label: clip(sw.getAttribute('data-color')),
        nav_destination: clip(sw.getAttribute('data-url')),
        collection_handle: COLLECTION_HANDLE
      });
      return;
    }

    /* Active-filter chip removal (and "Clear all") */
    var chip = target.closest('a.js-facet-remove');
    if (chip) {
      var isClear = chip.classList.contains('bh-sb-clear');
      track('blanks_filter_select', {
        filter_group: isClear ? '' : chipGroup(chip),
        filter_value: isClear ? 'all' : clip(chip.textContent.replace(/×/g, '')),
        filter_action: isClear ? 'clear_all' : 'remove',
        collection_handle: COLLECTION_HANDLE
      });
      return;
    }

    var link = target.closest('a[href]');
    if (!link) return;
    /* Ignore interactive controls nested inside card links (quick buy etc.) */
    if (target.closest('button, input, select, textarea')) return;

    for (var i = 0; i < NAV_RULES.length; i++) {
      if (link.matches(NAV_RULES[i][0])) {
        track('blanks_nav_click', {
          nav_method: NAV_RULES[i][1],
          nav_label: navLabel(link, NAV_RULES[i][1]),
          nav_destination: clip(link.getAttribute('href')),
          collection_handle: COLLECTION_HANDLE
        });
        return;
      }
    }
  }, true);

  /* ---------------- blanks_filter_select + blanks_sort_change ---------------- */

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!(input instanceof Element)) return;

    if (input.matches('select[name="sort_by"]')) {
      track('blanks_sort_change', { sort_value: input.value });
      return;
    }

    /* 'change' (not 'input'): the mobile filter drawer re-dispatches a synthetic
       'input' on every checkbox — listening on 'input' would double-fire. */
    if (input.matches('form.bh-sb-form input[type="checkbox"]')) {
      var details = input.closest('details.bh-sb-group');
      var label = details && details.querySelector('.bh-sb-group__label');
      /* Some facet groups submit a Shopify gid as the input value — report the
         visible option label instead (swatch title attr / checklist span). */
      var wrap = input.closest('label');
      var valueText = '';
      if (wrap) {
        valueText = wrap.classList.contains('bh-swatch-wrap')
          ? wrap.getAttribute('title')
          : (wrap.querySelector('span') || {}).textContent;
      }
      track('blanks_filter_select', {
        filter_group: label ? clip(label.textContent) : input.name,
        filter_value: clip(valueText) || clip(input.value),
        filter_action: input.checked ? 'apply' : 'remove',
        collection_handle: COLLECTION_HANDLE
      });
    }
  }, true);

  /* ---------------- search submits ---------------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof Element)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    var q = form.querySelector('input[name="q"]');
    track('blanks_nav_click', {
      nav_method: 'search',
      nav_label: clip(q && q.value),
      nav_destination: '/search',
      collection_handle: COLLECTION_HANDLE
    });
  }, true);
})();
